import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import { commentList } from "@/mocks/homeContent";

export default function CommentSection() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="talk" className="border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-page px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-[30px]">
                网友热议，评论区也在开会
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">
                有人补时间线，有人翻旧图，也有人提醒先别急着下定论。热闹归热闹，两边的话都值得看一眼。
              </p>
            </div>
            <a
              href="#download"
              className="flex shrink-0 items-center gap-1.5 self-start whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 md:text-sm"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-chat-3-line text-base" />
              </span>
              去 App 里接着聊
            </a>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {commentList.map((item, index) => (
            <Reveal key={item.id} delay={index * 70}>
              <article className="flex h-full gap-3.5 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-sm font-medium text-secondary-900">
                  {item.user.slice(0, 1)}
                </span>
                <div className="flex flex-1 flex-col">
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                    <span className="text-sm font-medium text-foreground-950">{item.user}</span>
                    <span className="rounded-full bg-background-100 px-2 py-0.5 text-xs text-foreground-500">
                      {item.role}
                    </span>
                    <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-800">
                      {item.tag}
                    </span>
                  </div>

                  <p className="mt-2.5 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
                    {item.text}
                  </p>

                  <div className="mt-3.5 flex items-center gap-4">
                    <button
                      type="button"
                      onClick={() => toggleLike(item.id)}
                      className={
                        liked[item.id]
                          ? "flex cursor-pointer items-center gap-1.5 text-xs text-primary-600"
                          : "flex cursor-pointer items-center gap-1.5 text-xs text-foreground-500 transition-colors hover:text-primary-600"
                      }
                    >
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className={liked[item.id] ? "ri-thumb-up-fill text-base" : "ri-thumb-up-line text-base"} />
                      </span>
                      {item.likes + (liked[item.id] ? 1 : 0)}
                    </button>
                    <button
                      type="button"
                      className="flex cursor-pointer items-center gap-1.5 text-xs text-foreground-500 transition-colors hover:text-primary-600"
                    >
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-chat-1-line text-base" />
                      </span>
                      回复
                    </button>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}